export const DASHBOARD_CONFIGS = {
  page1: {
    topLeft: {
      title: 'WWD1',
      producerIds: [1,2,6,7,46,47,48,49,50,51,52,53,54,55,56,57,63,80,81,82,83,96],
      tickPositions: [0,0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,1]
    },
    topRight: {
      title: '2 Mw',
      producerIds: [3, 4, 64, 65, 66, 31, 32, 33, 34, 35, 36],
      tickPositions: [0, 0.5, 1, 1.5, 2]
    },
    bottomLeft: {
      title: '3 Mw',
      producerIds: [103, 104, 105, 79, 37, 38, 39, 40, 41, 42],
      tickPositions: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4]
    },
    bottomRight: {
      title: 'DEIF',
      producerIds: [97, 113, 114, 115, 116, 117, 106, 108, 109, 123, 124, 125, 126, 127, 127, 130, 131],
      tickPositions: [0, 0.5, 1, 1.5, 2]
    }
  },
  page2: {
    topLeft: {
      title: 'Eoliennes 3MW - Buire le Sec',
      producerIds: [8, 9, 12, 13, 14, 15, 16, 17, 18, 19],
      tickPositions: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5]
    },
    topRight: {
      title: 'Eoliennes 3MW - Eplessier',
      producerIds: [20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      tickPositions: [0, 0.5, 1, 1.5, 2, 2.5, 3]
    },
    bottomLeft: {
      title: 'Eoliennes GE 2,85MW',
      producerIds: [43, 44, 45, 88, 93, 94, 95, 89, 90, 91, 92],
      tickPositions: [0, 0.5, 1, 1.5, 2, 2.5, 3]
    },
    bottomRight: {
      title: 'DIAZ', //TODO
      producerIds: [],
      tickPositions: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5]
    }
  },
  page3: {
    topLeft: {
      title: 'Oualidia (7h-17h: 58.6 €/MWh 17h-22h: 100.6 €/MWh  22h-7h: 38.6 €/MWh)',
      producerIds: [67,68,69,70,71,72,73,74,75,76,77,78],
      tickPositions: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5]
    },
    topRight: {
      title: 'Suède',
      producerIds: [58,59,60,61,62,98,99,100,101,102,139,140,141,207,208],
      tickPositions: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5]
    },
    bottomRight: {
      grafanaUrl: 'https://grafana.innovent.fr/d/2g0IzzwNk/prix-spot-fr-dashboardtv3?orgId=1&refresh5s&theme=dark&kiosk'
    }
  },
  page4: {
    topLeft: {
      grafanaUrl: 'https://grafana.innovent.fr/d/f0OWiWQNk/dashboard-tv-4?orgId=1&refresh=1m&theme=dark&kiosk'
    },
  },
  page5: {
    topLeft: {
      grafanaUrl: 'https://grafana.innovent.fr/d/e4b51a80-b896-44e1-bea8-088942127d87/buro?orgId=1&refresh=5s&theme=dark&kiosk'
    },
  },
}